module.exports = __webpack_public_path__ + "img/龙猫ip-icon.925d073d.png";